/**
 * Filter controller.
 *
 * This class controls filter areas
 */

 // Use jQuery as $ within this file scope.
 const $ = jQuery;

/**
 * Class Filter
 */
class Filter {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

        // Object to hold all filter areas.
        this.filterAreasById = {};
    }

    /** 
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.$buttons = $( '.js-filter-ctrl' );

        // Save an object of all filter areas panes.
        $( '.js-filter-area' ).each( ( index, element ) => {
            this.registerFilterArea( element );
        });
    }

    /**
     * Register a new filter area.
     *
     * @param {*} element Dom element to register. 
     * @memberof Filter
     */
    registerFilterArea( element ) {

        // Every filter area must have an unique ID.
        if ( element.id ) {

            const filterAreaObj = {
                'element': element,
                'keys': []
            };

            this.filterAreasById[element.id] = filterAreaObj;
        }
    }

    /**
     * Handles filter control click event.
     * 
     * @param {event object} e The click event.
     * @param {dom node} button The clicked filter control element.
     */
    filterClickHandle( e, button ) {
        Theme.Common.stop( e );

        const filterAreaId =  button.dataset.filterArea;
        const filterKey = button.dataset.filterKey.toString();

        if ( filterAreaId && filterKey ) {
            this.filter( filterAreaId, filterKey );
        }

    }

    /**
     * Updates the filter keys for filter-area with the given key. Then calls methods to update items and buttons.
     *
     * @param {string} filterAreaId ID of filter area to update.
     * @param {string} filterKey    Filter key that should be added or removed from the area.
     * @returns
     * @memberof Filter
     */
    filter( filterAreaId, filterKey ) {

        // Return early if area with given key not found.
        if ( ! this.filterAreasById[filterAreaId]) {
            return;
        }

        const areaKeys =  this.filterAreasById[filterAreaId].keys;

        // Remove the item from the array if it already existed in it. Otherwise add it to the array.
        if ( areaKeys.includes( filterKey ) ) {
            this.filterAreasById[filterAreaId].keys = areaKeys.filter( item => item !== filterKey );
        } else {
            this.filterAreasById[filterAreaId].keys.push( filterKey );
        }

        // The filtering is primarily used for the some-feed. The some-feed should by default show all items. Because
        // of that, we show all items if no filter is selected.
        const makeAllItemsActive = this.filterAreasById[filterAreaId].keys.length < 1;

        this.updateItemsStatus( filterAreaId, makeAllItemsActive );

        // Changing the button status here instead of earlier, when clicked. Enables us to have multiple buttons with
        // the same filter key. Eg. before and after the filter area.
        this.updateButtonsStatus( filterAreaId );

        // Create a custom event so that other classes can react when something is filtered.
        const filterEvent = document.createEvent( 'CustomEvent' );

        // Pass the keys and the id of the filter area as detail-data since it might be useful.
        filterEvent.initCustomEvent( 'dptfilter', true, true, { filterAreaId, areaKeys });

        // Dispatch the custom event.
        this.filterAreasById[filterAreaId].element.dispatchEvent( filterEvent );
    }

    /**
     * Update each filter-item in filter area with given id.
     *
     * @param {string} filterAreaId         Id of filter area with the items to update. 
     * @param {boolean} [activateAll=false] Set to true to make all items active.
     * @memberof Filter
     */
    updateItemsStatus( filterAreaId, activateAll = false ) {
        const areaKeys =  this.filterAreasById[filterAreaId].keys;
        $( this.filterAreasById[filterAreaId].element ).find( '.js-filter-item ' ).each( ( index, item ) => {

            if ( activateAll ) {
                item.classList.add( 'js-filter-item-active' );
                item.classList.remove( 'js-filter-item-inactive' );
                return;
            }

            const filterKey = item.dataset.filter;

            if ( areaKeys.includes( filterKey ) ) {
                item.classList.add( 'js-filter-item-active' );
                item.classList.remove( 'js-filter-item-inactive' );
            } else {
                item.classList.remove( 'js-filter-item-active' );
                item.classList.add( 'js-filter-item-inactive' );
            }
        });
    }

    /**
     * Update each filter-control for filter area with given id.
     *
     * @param {string} filterAreaId Id of filter area with the items to update. 
     * @memberof Filter
     */
    updateButtonsStatus( filterAreaId ) {
        const areaKeys =  this.filterAreasById[filterAreaId].keys;
        this.$buttons.each( ( index, button ) => {

            const filterArea =  button.dataset.filterArea;
            const filterKey = button.dataset.filterKey.toString();

            // Return early if this is not a button that controls the current area.
            if ( filterArea != filterAreaId ) {
                return;
            }

            if ( areaKeys.includes( filterKey ) ) {
                button.classList.add( 'js-filter-active' );
            } else {
                button.classList.remove( 'js-filter-active' );
            }
        });
    }

    /**
     * Run when the document is ready.
     * @return {void}
     */
    docReady() {
        this.cache();
    }
}

// Export the class reference.
module.exports = Filter;



// WEBPACK FOOTER //
// ./assets/scripts/filter.js